<template>
  <main>
    <dsf-text>
      This is your shell, now you are able to connect µFs to your application
    </dsf-text>
    <RouterView />
  </main>
</template>

<script lang="ts" setup>
import { RouterView } from 'vue-router'
import { loadStyles, themeProvider, Themes } from '@sennder/design-system-core'
import { onMounted } from 'vue'

onMounted(() => {
  loadStyles('#app')
  themeProvider('body', Themes.Light)
})
</script>
